import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'MARKET_ADMIN_DEVICE_DETAIL',
        create: 'MARKET_ADMIN_DEVICE_CREATE',
        update: 'MARKET_ADMIN_DEVICE_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [
      /* {
        prop: 'market_mobile',
        default: '',
        label: 'market_mobile',
        col: { span: 16 },
        rule: { required: true, message: 'required', trigger: 'change' },
        render: () => <el-input vModel={ this.form.model.market_mobile } clearable/>
      }, */
      {
        prop: 'admin_id',
        default: '',
        label: this.$t('admin_id'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        // render: () => <el-input vModel={ this.form.model.admin_account } clearable/>
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "form_admin_id",
              "custom": true,
              "stringify": true
            },
            "model": {
              value: _this.form.model.admin_id,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "admin_id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'device_uid',
        default: '',
        label: this.$t('device_uid'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        // render: () => <el-input vModel={ this.form.model.device_number } clearable/>
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "form_device_uid",
              "custom": true,
              "stringify": true
            },
            "model": {
              value: _this.form.model.device_uid,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "device_uid", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: {
    loadDict: function loadDict() {
      this.loadDictOne({
        name: 'form_admin_id',
        method: this.$api.MARKET_ADMIN_ALL,
        fields: 'id,admin_account',
        path: 'list',
        label: 'admin_account',
        value: 'id'
      });
      this.loadDictOne({
        name: 'form_device_uid',
        method: this.$api.DEVICE_ALL,
        fields: 'device_uid,device_name',
        path: 'list',
        label: 'device_name',
        value: 'device_uid'
      });
    }
  }
};